/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { comparatorQtr } from '../../../../../SharedModules/utilities/utilities';

function auditCountsComparator(amount1, amount2) {
  if (amount1 === null && amount2 === null) {
    return 0;
  }
  if (amount1 === null) {
    return -1;
  }
  if (amount2 === null) {
    return 1;
  }

  return amount1 - amount2;
}
export const TableHeaderForCMSRosiDetail = [
  {
    headerName: 'Discrepancy Cleared',
    field: 'discrepancyCleared',
    showCheckboxIcon: true,
    hideFilterIcon: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: false,
    filter: false,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellClass: 'ag-cell-action',
    cellRenderer: 'CheckBoxCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'ag-cell-action frr-overflow-visible',
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_150,
    cellRenderer: 'NDCCellRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'DrugNameRenderer',
    cellStyle: {
      'border-right-color': Styles.BorderColor,
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Status',
    field: 'status',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    autoHeight: true,
    wrapText: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Discrepancy Type',
    field: 'discrepancyTypeLongDesc',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    columnSpan: 4,
    autoHeaderHeight: true,
    minWidth: Styles.Width_250,
    sortingOrder: ['desc', 'asc'],
    autoHeight: true,
    wrapText: true,
    cellRenderer: 'DiscrepancyRenderer',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Quarter',
    field: 'qurater',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_125,
    comparator: comparatorQtr,

    sortingOrder: ['desc', 'asc'],
    autoHeight: true,
    wrapText: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CMS URA',
    field: 'cmsUra',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    autoHeight: true,
    wrapText: true,
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Payment URA',
    field: 'paymentUra',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    autoHeight: true,
    wrapText: true,
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
//   NDC AND LABEL NAME TABLE
export const TableHeaderForManufacturer = [
  {
    headerName: ' Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sort: 'asc',
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const TableHeaderForNDCLevelDetail = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    // maxWidth: Styles.Width_150,
    minWidth: Styles.Width_150,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'ag-cell-action frr-overflow-visible',
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_150,
    cellRenderer: 'NDCCellRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_500,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Audits',
    field: 'auditCounts',
    comparator: auditCountsComparator,
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
